import { render, staticRenderFns } from "./ModalStore.vue?vue&type=template&id=a2d1cf4c&"
import script from "./ModalStore.vue?vue&type=script&lang=js&"
export * from "./ModalStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports